import type { ReportBlock } from '@/lib/types/report'
import { Markdown } from '@/components/chat/Markdown'
import { Callout } from '../primitives/Callout'
import { FillErrorNotice } from '../primitives/FillErrorNotice'

export function FindingCallout({ block }: { block: ReportBlock }) {
  const fillError = block.data.fill_error
  if (fillError) return <FillErrorNotice error={String(fillError)} />
  return (
    <Callout variant="finding">
      <div className="report-prose text-[0.95rem]">
        <Markdown>{String(block.data.prose ?? '')}</Markdown>
      </div>
    </Callout>
  )
}
